export default {
  data () {
    return {
      inputValue: ''
    }
  },
  props: {
    emptyField: {
      type: String,
      required: true
    },
    invalidEmail: {
      type: String,
      required: true
    },
    form: {
      type: String,
      required: true
    }
  },
  beforeMount () {
    if (navigator.userAgent.indexOf('iPhone') > -1) {
      document
        .querySelector('[name=viewport]')
        .setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1')
    }
  },
  mounted () {
    document.getElementById('validate').addEventListener('click', () => {
      if (this.isValid(this.form)) {
        document.getElementById('submitButton').click()
      }
    })

    document.getElementById('validateRecover').addEventListener('click', () => {
      if (this.isValid('#recover_customer_password')) {
        document.getElementById('submitButtonRecover').click()
      }
    })
  },
  methods: {
    isValid (validationType) {
      const errorSpans = document.querySelectorAll('span.errors')
      let isValid = true
      const requiredFields = document.querySelectorAll('.required')

      errorSpans.forEach(span => {
        span.parentNode.classList.remove('floating-input--error')
        span.parentNode.removeChild(span)
      })

      requiredFields.forEach(field => {
        if (field.tagName === 'INPUT') {
          const inputType = field.type

          if (field.closest('form' + validationType)) {
            if (this.isEmpty(field.value)) {
              this.addErrorStyling(field, this.emptyField)
              isValid = false
            } else if (inputType === 'email' && !this.validateEmail(field.value)) {
              this.addErrorStyling(field, this.invalidEmail)
              isValid = false
            }
          }
        }
      })

      return isValid
    },
    validateEmail (fieldValue) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(fieldValue)
    },
    isEmpty (fieldValue) {
      return fieldValue === null || typeof fieldValue === 'undefined' || fieldValue.trim() === ''
    },
    addErrorStyling (field, message) {
      const errorMessageElement = document.createElement('span')
      const labelForField = document.querySelector(`label[for="${field.id}"]`)

      errorMessageElement.classList.add('errors')
      errorMessageElement.textContent = message

      if (labelForField) {
        labelForField.parentNode.insertBefore(errorMessageElement, labelForField.nextSibling)
      } else {
        field.parentNode.insertBefore(errorMessageElement, field.nextSibling)
      }

      field.parentNode.classList.add('floating-input--error')
    }
  }
}
